import { gql } from '@apollo/client';

export const RETRY_SETTLEMENT_IMPORT_TASK = gql`
  mutation RetrySettlementImportTask($taskId: Long!) {
    retrySettlementImportTask(taskId: $taskId)
  }
`;

export const CANCEL_SETTLEMENT_IMPORT_TASK = gql`
  mutation CancelSettlementImportTask($taskId: Long!) {
    cancelSettlementImportTask(taskId: $taskId)
  }
`;
